import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
    selector: 'op-product-dashboard-fees',
    templateUrl: './product-dashboard-fees.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ProductDashboardFeesComponent {

}